import React from "react";
import { Tab } from "react-admin";
import { PickingList } from "./PickingList";

export const PickingListTab = (props) => {
	if (!props.record?.id) return null;
	return (
		<Tab label="Picking List" {...props}>
			<PickingList
				orderId={props.record.id}
				terminalId={props.record.terminal_id}
				orderPallets={props.record.pallets}
				orderStatus={props.record.status}
				{...props}
			/>
		</Tab>
	);
};
